import { BaseApiService } from '../../../api/base';
import type {
  UserNotificationSettings,
  UserNotificationUpdate,
} from '../types/notifications';

class NotificationsApiService extends BaseApiService {
  public updateNotificationSettings(
    settings: UserNotificationUpdate
  ): Promise<UserNotificationSettings[]> {
    return this.post<UserNotificationSettings[]>(
      'notification/settings/params',
      settings
    );
  }
}

export const notificationsApiService = new NotificationsApiService();
